import { ExaminationMenuType } from '@/features/reservation/types/ExaminationMenuType';

export function getMergedMenuList(
  examinationMenuList: ExaminationMenuType[],
  vipMenu: ExaminationMenuType[],
  exoMenu: ExaminationMenuType[],
  subscriptionMenu: ExaminationMenuType[],
  vipWithExoMenu: ExaminationMenuType[],
  vipWithSubscriptionMenu: ExaminationMenuType[],
  isVip: boolean,
  isExo: boolean,
  isSubscription: boolean
): ExaminationMenuType[] {
  let menus: ExaminationMenuType[] = [...examinationMenuList];

  if (isVip) {
    menus = menus.concat(vipMenu);
    if (isSubscription) menus = menus.concat(vipWithSubscriptionMenu);
    if (isExo) menus = menus.concat(vipWithExoMenu);
  } else {
    if (isSubscription) menus = menus.concat(subscriptionMenu);
    if (isExo) menus = menus.concat(exoMenu);
  }

  // outpatientIdで重複除去
  const seen = new Set<string>();
  return menus.filter((menu) => {
    if (seen.has(menu.outpatientId)) return false;
    seen.add(menu.outpatientId);
    return true;
  });
}
